import { useMemo, useState } from 'react'
import Button from 'antd/lib/button'
import { PanelHeader } from 'Components/common/TaskPanelHeader/TaskPanelHeader'
import PlagiarismCheckerIcon from 'Assets/icons/plagiarism-checker.svg'
import { DisabledStateType, PlagiarismDetailsType } from 'Plugins/Plagiarism/Plagiarism.plugin'
import { CircleLoader } from 'shared/components/CircleLoader/CircleLoader'
import { PlagiarismDetails } from 'Plugins/Plagiarism/component/PlagiarismDetails/PlagiarismDetails'
import Tooltip from 'antd/lib/tooltip'
import classes from 'Plugins/Plagiarism/component/PlagiarismChecker.module.less'

export type PlagiarismCheckerProps = {
    onCheckForPlagiarism: () => Promise<void>
    getPlagiarismDetails: () => PlagiarismDetailsType | undefined
    getDisabledState: () => DisabledStateType
}

export const PlagiarismCheckerComponent: React.FC<PlagiarismCheckerProps> = (
    props: PlagiarismCheckerProps
) => {
    const [isLoading, setIsLoading] = useState(false)
    const plagiarismDetails = props.getPlagiarismDetails()

    const mode: 'loading' | 'details' | 'hint' = useMemo(() => {
        if (isLoading) {
            return 'loading'
        }
        if (plagiarismDetails) {
            return 'details'
        }
        return 'hint'
    }, [isLoading, plagiarismDetails])

    return (
        <div className={classes.plagiarismRoot}>
            <PanelHeader logo={PlagiarismCheckerIcon} title={'Plagiarism Checker'} />
            <div className={classes.body}>
                {(() => {
                    switch (mode) {
                        case 'loading':
                            return (
                                <div className={classes.loadingContainer}>
                                    <CircleLoader size={28} />
                                    <div>Scanning...Please wait...</div>
                                </div>
                            )
                        case 'hint':
                            return (
                                <div className={classes.hintText}>
                                    Click on “Scan for plagiarism” to check your response.
                                </div>
                            )
                        case 'details':
                            return <PlagiarismDetails details={plagiarismDetails} />
                        default:
                            return null
                    }
                })()}
            </div>
            <div className={classes.footer}>
                <Tooltip trigger="hover" title={props.getDisabledState().reason}>
                    <Button
                        className={classes.scanButton}
                        onClick={async () => {
                            setIsLoading(true)
                            await props.onCheckForPlagiarism()
                            setIsLoading(false)
                        }}
                        disabled={isLoading || props.getDisabledState().isDisabled}
                    >
                        {plagiarismDetails ? 'Scan again for plagiarism' : 'Scan for plagiarism'}
                    </Button>
                </Tooltip>
            </div>
        </div>
    )
}
